// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as ServicosRouteImport } from './routes/servicos'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const ServicosRoute = ServicosRouteImport.update({
            id: '/servicos',path: '/servicos',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,SlugRoute: SlugRoute,AuthRoute: AuthRoute,ContatoRoute: ContatoRoute,ServicosRoute: ServicosRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)